import { createStore } from 'vuex'
import axios from 'axios';

export default createStore({
  state: {
    data: {},
    isMuted: true,
    activeRol: undefined,
    activeIndex: undefined,
    prevRol: undefined,
    nextRol: undefined,
    drawerIsVisible: false,
    visited: [],
    showModal: false,
    modalData: undefined
  },
  mutations: {
    SAVE_DATA (state, data) {
      state.data = data.data.attributes;
    }, 

    TOGGLE_MUTE(state) {
      state.isMuted = !state.isMuted;
    },

    PRESENT_MODAL(state, data) {
      state.modalData = data;
      state.showModal = true;
    },

    DISMISS_MODAL(state) {
      state.showModal = false;
    },

    UPDATE_ROL(state, rol) {
      rol.visited = true;
      state.activeRol = rol;
      state.activeIndex = state.data.rol.findIndex((item)=> item.title === rol.title);
    },

    RESET_ROL(state) {
      state.activeRol = undefined;
      state.activeIndex = undefined;
    },

    UPDATE_PREV(state) {
      let prev = state.activeIndex -1;

      if (prev < 0) {
        prev = state.data.rol.length - 1;
      }

      state.prevRol = state.data.rol[prev];
    },

    UPDATE_NEXT(state) {
      let next = state.activeIndex + 1;

      if (next >  state.data.rol.length - 1) {
        next = 0;
      }

      state.nextRol = state.data.rol[next];
    },

    UPDATE_DRAWER(state, isShown) {
      state.drawerIsVisible = isShown;
    }
  },
  getters: {
    data: state => state.data,
    isMuted: state => state.isMuted,
    activeRol: state => state.activeRol,
    drawerIsVisible: state => state.drawerIsVisible,
    modalData: state => state.modalData
  },
  actions: {
    loadData ({ commit, state }) {


      return new Promise((resolve, reject) => { 
        let base = process.env.NODE_ENV === 'development' ? '' : process.env.VUE_APP_PATH;
        axios
          .get(base + process.env.VUE_APP_API)
          .then(result => {
            commit("SAVE_DATA", result.data);
            resolve();
          })
          .catch(error => {
            reject();
            throw new Error(`API ${error}`);
          });
      })
    },    

    toggleSound({commit, state}) {
      commit("TOGGLE_MUTE");
    },

    presentModal({commit, state},data) {
      commit("PRESENT_MODAL", data);
    },

    dismissModal({commit}) {
      commit("DISMISS_MODAL");
    },

    updateRol({commit, state}, rol) {
      commit("UPDATE_ROL", rol);
      commit("UPDATE_NEXT");
      commit("UPDATE_PREV");
    },

    updateDrawer({commit}, isShown) {
      commit("UPDATE_DRAWER", isShown);
    }
  },
  modules: {

  }
})
